import React, { useEffect } from 'react';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Head from "../components/Head";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Button from "../components/Button";
import {Carousel} from "react-bootstrap";

function Home() {
  // Add animation and carousel initialization when the component mounts
  useEffect(() => {
    // Animate hero text elements when page loads
    const animateHeroText = () => {
      const textElements = document.querySelectorAll('.hero-text-animate');
      textElements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('show');
        }, 300 * index);
      });
    };

    // Initialize Bootstrap carousel programmatically to ensure it starts automatically
    const initCarousel = () => {
      const carousel = document.querySelector('#header');
      if (carousel && typeof window !== 'undefined' && window.bootstrap) {
        // Using Bootstrap 5 Carousel initialization
        const bsCarousel = new window.bootstrap.Carousel(carousel, {
          interval: 5000, // Time between slide transitions (5 seconds)
          ride: 'carousel', // Auto-start sliding
          wrap: true // Allows the carousel to cycle continuously
        });
        // Force the carousel to cycle immediately
        bsCarousel.cycle();
      }
    };

    // Start animations and carousel after a short delay
    setTimeout(() => {
      animateHeroText();
      initCarousel();
    }, 500);

    // Clean up function
    return () => {
      const carousel = document.querySelector('#header');
      if (carousel && typeof window !== 'undefined' && window.bootstrap) {
        const carouselInstance = window.bootstrap.Carousel.getInstance(carousel);
        if (carouselInstance) {
          carouselInstance.dispose();
        }
      }
    };
  }, []);

  return (
      <>
        <Head pageTitle="AMR - Home"/>
        <NavigationBar />

        <style jsx="true">{`
          /* Text carousel styles */
          .carousel-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 0;
          }

          .video-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1;
          }

          .carousel-section {
            position: relative;
            z-index: 2;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          }

          .carousel-wrapper {
            position: relative;
            overflow: hidden;
          }

          .carousel {
            position: relative;
            z-index: 2 !important;
          }

          .carousel-caption {
            z-index: 3;
            position: relative;
            text-align: left;
            left: 5%;
          }

          .carousel-inner {
            max-width: 1200px;
          }

          .carousel-subheading {
            font-size: 2.5rem;
            color: #fff;
            margin-bottom: 10px;
            text-transform: capitalize;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.8s ease, transform 0.8s ease;
          }

          .carousel-heading {
            font-size: 4rem;
            font-weight: 700;
            color: #fff;
            text-transform: uppercase;
            margin-bottom: 30px;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.8s ease, transform 0.8s ease;
            transition-delay: 0.2s;
          }

          .hero-text-animate.show {
            opacity: 1;
            transform: translateY(0);
          }

          .carousel-buttons {
            display: flex;
            gap: 15px;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.8s ease, transform 0.8s ease;
            transition-delay: 0.4s;
          }

          .carousel-btn {
            padding: 12px 30px;
            background-color: #DBA800;
            color: white;
            border: none;
            border-radius: 5px;
            font-weight: 600;
            transition: all 0.3s ease;
            text-decoration: none;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .carousel-btn:hover {
            background-color: #c29600;
            transform: translateY(-3px);
          }

          .carousel-btn.outline {
            background-color: transparent;
            border: 2px solid white;
          }

          .carousel-btn.outline:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }

          /* Responsive adjustments */
          @media (max-width: 992px) {
            .carousel-subheading {
              font-size: 2rem;
            }

            .carousel-heading {
              font-size: 3rem;
            }

            .carousel-text-container {
              margin-left: 30px;
            }
          }

          @media (max-width: 768px) {
            .carousel-subheading {
              font-size: 1.8rem;
            }

            .carousel-heading {
              font-size: 2.5rem;
              margin-bottom: 20px;
            }

            .carousel-text-container {
              margin-left: 20px;
            }

            .carousel-btn {
              padding: 10px 20px;
            }
          }

          @media (max-width: 576px) {
            .carousel-subheading {
              font-size: 1.5rem;
            }

            .carousel-heading {
              font-size: 2rem;
            }

            .carousel-text-container {
              margin-left: 10px;
              padding: 0 10px;
            }

            .carousel-buttons {
              flex-direction: column;
              gap: 10px;
              width: 200px;
            }

            .carousel-control-prev,
            .carousel-control-next {
              display: none;
            }
          }
        `}</style>

        <div className="carousel-wrapper">
          <video
              className="carousel-background"
              src="/background-vid/0403.mp4"
              autoPlay
              loop
              muted
              playsInline
          />
          <div className="video-overlay"></div>
          <Carousel className={"carousel-section"}>
            <Carousel.Item interval={5000}>
              <Carousel.Caption>
                <h2 className="carousel-subheading hero-text-animate">best cars</h2>
                <h1 className="carousel-heading hero-text-animate">newest models</h1>
                <div className="carousel-buttons hero-text-animate">
                  <Button btnType={"primary"} btnName={"Explore Fleet"} to={"/fleet"}/>
                  <Button btnType={"secondary"} btnName={"Book Now"} to={"/reservations"}/>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <Carousel.Caption>
                <h2 className="carousel-subheading hero-text-animate">best prices</h2>
                <h1 className="carousel-heading hero-text-animate">affordable experiences</h1>
                <div className="carousel-buttons hero-text-animate">
                  <Button btnType={"primary"} btnName={"See Rates"} to={"/rates"}/>
                  <Button btnType={"secondary"} btnName={"Book Now"} to={"/reservations"}/>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <Carousel.Caption>
                <h2 className="carousel-subheading hero-text-animate">unique experiences</h2>
                <h1 className="carousel-heading hero-text-animate">for parties & weddings</h1>
                <div className="carousel-buttons hero-text-animate">
                  <Button btnType={"primary"} btnName={"Book Event"} to={"/reservations"}/>
                  <Button btnType={"secondary"} btnName={"Contact Us"} to={"/contactus"}/>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
        <Footer/>
      </>
  );
}

export default Home;